// LATER
// module.exports = require("./new");
module.exports = require("./legacy");



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-workflow-compile/index.js
// module id = 525
// module chunks = 0 1